import classNames from 'classnames';
import React from 'react';

import Icon from '../Icon/Icon';
import Link from '../Link/Link';
import * as styles from './FeaturedLink.module.scss';

const Inner = ({ label, desc, as: Comp = 'h3' }) => (
  <>
    <Comp className={styles.title}>
      <span>{label}</span>
      <Icon className={styles.icon} name="arrow-right" />
    </Comp>

    {desc && 
      <p className={styles.desc}>
        {desc.length > 110 ? `${desc.substring(0,110)}...` : desc }
      </p>
    }
  </>
);

const FeaturedLink = ({ path, isSecondary = false, ...other }) => {
  const className = classNames(styles.featuredLink, {
    [ styles.isSecondary ]: isSecondary
  });

  return path ? (
    <Link className={className} to={path}>
      <Inner {...other} />
    </Link>
  ) : (
    <div className={className}>
      <Inner {...other} />
    </div>
  );
};

export default FeaturedLink;
